import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function avatarShow(
    accessory_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/accessory/avatar/${accessory_id}/show${queryString}`
    );
}

export async function avatarCreate(
    accessory_id: string,
    image_id: string
) {
    return await clientAxios.post(
        `admin/accessory/avatar/${accessory_id}/create`,
        { image_id }
    );
}

export async function avatarUpdate(
    accessory_id: string,
    image_id: string
) {
    return await clientAxios.put(
        `admin/accessory/avatar/${accessory_id}/update`,
        { image_id }
    );
}

export async function avatarDelete(
    accessory_id: string,
) {
    return await clientAxios.del(
        `admin/accessory/avatar/${accessory_id}/delete`,
    );
}
